export type Rate = {
  flatRate?: string
  perMileRate?: number
}

export function hasRateValue(flatRate?: string) {
  if (!flatRate) return false

  return Number(flatRate) > 0
}

export function hasRatePerMile(ratePerMile?: number, mileage?: number) {
  return Boolean(mileage) && Boolean(ratePerMile)
}

/**
 * When `initialRate` it's present, it's returned, otherwise `currentRate` or 0
 * @param initialRate It's the submitted value fetched from backend
 * @param currentRate  It's the value that is typed by the user
 * @returns initialRate | currentRate
 */
export function getRateValue(initialRate?: string | number, currentRate?: number): number {
  const hasInitialRate = Boolean(initialRate)

  if (hasInitialRate) {
    return Number(initialRate)
  }

  return currentRate ?? 0
}
